import React from "react";
import { Spinner } from "reactstrap";
import { useSearchParams } from "../../lib/hooks/useSearchParams";
import { useShopHandlers } from "../../lib/hooks/useShopHandlers";
import { useShopFilterData } from "../../lib/hooks/useShopFilterData";
import { useShopContext } from "../../lib/context/ShopContext/ShopContext";

import "./ShopBySubCategories.scss";

export const ShopBySubCategories = () => {
  const shopCtx = useShopContext();
  const shopHandlers = useShopHandlers();
  const searchParams = useSearchParams();
  const shopFilterData = useShopFilterData();

  const brand = searchParams["brand"];
  const hasBrand = !!searchParams["brand"];
  const hasOnHot = !!searchParams["tenxehta"];
  const hasNewProducts = !!searchParams["tereja"];

  const handleClickSubCategory = (selectOption: string) => {
    const pathName = selectOption
      ? `/${shopFilterData?.redirectLinkPrefix}/${shopCtx?.data?.category}/${selectOption}`
      : `/${shopFilterData?.redirectLinkPrefix}/${shopCtx?.data?.category}`;
    shopFilterData?.handleCategoryChange(selectOption || "");
    shopHandlers.updatePathname(
      pathName,
      true,
      hasOnHot
        ? "tenxehta=true"
        : undefined || hasNewProducts
        ? "tereja=true"
        : undefined || hasBrand
        ? `brand=${brand}`
        : undefined
    );
  };
  if (shopFilterData?.loading) {
    return <Spinner style={{ marginLeft: 30 }} size="lg" color="#000" />;
  }

  if (shopFilterData?.selectedSubCategory) {
    return <div />;
  }

  return (
    <div className="ShopBySubCategories">
      <div className="ShopBySubCategories__desc">
        <p>{shopFilterData?.subCategoryOptions?.description}</p>
      </div>
      <div className="ShopBySubCategories__wrapper">
        {shopFilterData?.subCategoryOptions?.subCategoryOptions?.map(
          (item, index) => {
            return (
              <div
                key={index}
                onClick={() => handleClickSubCategory(item.value)}
                className="ShopBySubCategories__wrapper-item"
              >
                {item?.icon ? (
                  <div className="ShopBySubCategories__wrapper-item--img">
                    <img src={item?.icon} alt="category" />
                  </div>
                ) : null}
                <label>{item.label}</label>
              </div>
            );
          }
        )}
      </div>
    </div>
  );
};
